<template>
  <form class="quick-category" @submit.prevent="onSubmit">
    <div class="quick-category__grid">
      <div class="quick-category__field">
        <label>نام تگ</label>
        <input v-model="form.name" type="text" class="form-control" placeholder="نام تگ">
      </div>
      <div class="quick-category__field">
        <label>زبان</label>
        <select class="form-control custom-select" v-model="form.language_id">
          <option value="">انتخاب زبان</option>
          <option v-for="language in languages" :key="language.id" :value="language.id">
            {{ language.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="quick-category__field">
      <label>نوع تگ</label>
      <div class="quick-tag-types">
        <label class="quick-tag-types__item" v-for="(label, key) in tagModelNames" :key="key">
          <input v-model="form.tag_types" type="checkbox" :value="key">
          <span>{{ label }}</span>
        </label>
      </div>
    </div>

    <div class="quick-category__actions">
      <button type="submit" class="quick-category__submit" :disabled="loading">
        {{ loading ? 'در حال ثبت...' : 'ثبت تگ' }}
      </button>
    </div>
  </form>
</template>

<script>
import {mapGetters} from 'vuex'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {tagModelNames} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Tag";

export default {
  name: "QuickTagCreate",
  data() {
    return {
      loading: false,
      tagModelNames,
      form: {
        name: '',
        language_id: '',
        tag_types: ['product'],
      }
    }
  },
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages",
    }),
  },
  methods: {
    async onSubmit() {
      if (!this.form.name || !this.form.language_id) {
        toast('خطا', 'نام و زبان الزامی است.')
        return
      }
      this.loading = true
      try {
        await this.$store.dispatch('Tag/createTag', this.form)
        toast('عملیات با موفقیت انجام شد', 'تگ با موفقیت ثبت شد.')
        this.$emit('created')
        this.form.name = ''
        this.form.tag_types = ['product']
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    const defaultLanguage = findAttributeOnSiteInfo('default_language')
    if (defaultLanguage && defaultLanguage[0]) {
      this.form.language_id = defaultLanguage[0].id
    }
  }
}
</script>

<style scoped>
.quick-category {
  display: grid;
  gap: 1rem;
}

.quick-category__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.quick-category__field label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 700;
  color: #424242;
}

.quick-category__field .form-control,
.quick-category__field .custom-select {
  border-radius: 12px;
}

.quick-tag-types {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
}

.quick-tag-types__item {
  display: inline-flex !important;
  align-items: center;
  gap: 0.35rem;
  margin: 0 !important;
  font-weight: 600 !important;
  cursor: pointer;
}

.quick-category__actions {
  display: flex;
  justify-content: flex-end;
}

.quick-category__submit {
  min-height: 44px;
  padding: 0 1.4rem;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
}

.quick-category__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 767.98px) {
  .quick-category__grid {
    grid-template-columns: 1fr;
  }
}
</style>
